// The product surfaces the business uses. Single source of truth shared by the
// cut form (CutUpdatedForm) and the map view filter (MapSidebar) so both offer the
// same options. The /products catalog can't be the source — it only
// reliably exposes `surface` for the Special rows.
export const SURFACE_OPTIONS = ['Asphalt', 'Concrete', 'Special'];

// Resolve the surface name for a cut. A cut that has specials is treated as a Special
// (additional work) cut regardless of its product. Otherwise the surface comes from the
// product object — `surface` when loaded from the API, or `id` for a fresh dropdown
// selection (PRODUCT_CHOICES stores `{ id: <surface name> }`).
export function resolveCutSurface(cut) {
    if (cut?.specials?.length) {
        return 'Special';
    }

    let prod = cut?.product;
    if (typeof prod === 'string' && prod !== '') {
        try {
            prod = JSON.parse(prod);
        } catch (error) {
            return null;
        }
    }

    if (prod && typeof prod === 'object') {
        return prod.surface ?? prod.id ?? null;
    }

    return null;
}

// Rewrite each cut's `product` into the `surface` string the API expects on write
// (e.g. `{ product: { id: "Asphalt" } }` => `{ surface: "Asphalt" }`). The backend
// resolves the configured product + pricing from the surface, so `product` is dropped.
export function applyCutSurfaces(values) {
    if (!Array.isArray(values?.cuts)) {
        return values;
    }

    return {
        ...values,
        cuts: values.cuts.map((cut) => {
            const surface = resolveCutSurface(cut);
            const { product, ...rest } = cut;

            return surface ? { ...rest, surface } : rest;
        }),
    };
}